import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  id: "asidemenutitle",
  style: {
    "background-color": "#002140",
    "color": "white",
    "padding-bottom": "5px"
  }
};
const _hoisted_2 = {
  style: {
    "font-size": "16px",
    "font-weight": "700",
    "color": "white"
  }
};
const _hoisted_3 = {
  style: {
    "font-weight": "bold",
    "font-size": "16px",
    "color": "white"
  }
};
const _hoisted_4 = {
  style: {
    "font-size": "13px",
    "color": "white"
  }
};
const _hoisted_5 = {
  style: {
    "height": "59px",
    "padding": "15px 30px 0 10px"
  }
};
const _hoisted_6 = {
  style: {
    "height": "35px",
    "float": "left",
    "cursor": "pointer"
  }
};
const _hoisted_7 = {
  style: {
    "height": "35px",
    "float": "right"
  }
};
const _hoisted_8 = {
  class: "el-dropdown-link",
  style: {
    "vertical-align": "middle",
    "margin-left": "3px",
    "cursor": "pointer"
  }
};
const _hoisted_9 = {
  style: {
    "vertical-align": "middle",
    "margin-left": "3px",
    "cursor": "pointer"
  }
};
const _hoisted_10 = {
  style: {
    "width": "300px"
  }
};
const _hoisted_11 = {
  style: {
    "margin-right": "5px",
    "float": "left",
    "height": "45px"
  }
};
const _hoisted_12 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "16px"
  }
};
const _hoisted_13 = {
  style: {}
};
const _hoisted_14 = {
  style: {
    "margin-left": "50px",
    "line-height": "30px"
  }
};
const _hoisted_15 = {
  style: {
    "border": "1px solid gray",
    "padding": "10px"
  }
};
const _hoisted_16 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_17 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "16px"
  }
};
const _hoisted_18 = {
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px"
  }
}, "内容：", -1);
const _hoisted_20 = {
  style: {
    "width": "100",
    "text-align": "right"
  }
};
const _hoisted_21 = {
  style: {
    "width": "100%",
    "text-align": "right"
  }
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "font-weight": "400",
    "float": "left"
  }
}, "通知", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_Fold = _resolveComponent("Fold");
  const _component_Expand = _resolveComponent("Expand");
  const _component_Switch = _resolveComponent("Switch");
  const _component_Select = _resolveComponent("Select");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_InfoFilled = _resolveComponent("InfoFilled");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Finished = _resolveComponent("Finished");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "margin": "0",
      "padding": "0",
      "width": "100%",
      "height": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      class: _normalizeClass(["asidestyle", {
        'hideasidestyle': !$data.showaside
      }]),
      id: "baseaside",
      style: {
        "background-color": "#00152a"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$data.showaside ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "width": "100%",
          "text-align": "center",
          "font-size": "20px",
          "padding-top": "5px",
          "font-weight": "bold",
          "cursor": "pointer"
        },
        onClick: _cache[0] || (_cache[0] = (...args) => $options.jumptohome && $options.jumptohome(...args))
      }, "发票管理平台")) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["avatardiv", {
          'hideavatardiv': !$data.showaside
        }])
      }, [_createVNode(_component_el_avatar, {
        class: _normalizeClass(["avatarcontainer", {
          'hideavatarcontainer': !$data.showaside
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$store.state.current_user.Display), 1)]),
        _: 1
      }, 8, ["class"])], 2)]), _createVNode(_component_el_container, {
        style: {
          "margin": "0",
          "padding": "0"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_main, {
          style: _normalizeStyle([$data.asidemainstyle, {
            "scrollbar-width": "none"
          }])
        }, {
          default: _withCtx(() => [_createVNode(_component_el_menu, {
            ref: "basemenu",
            style: {
              "width": "100%",
              "border": "0"
            },
            collapse: !$data.showaside,
            "collapse-transition": false,
            "default-openeds": [...Array(10).keys()],
            "background-color": "#00152a",
            "default-active": _ctx.$store.state.menuclicknow,
            "text-color": "#fff",
            router: "",
            closable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.menulist, menu => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: menu
              }, [menu.Path == '/' ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: "home",
                onClick: _cache[1] || (_cache[1] = () => {
                  this.$store.commit('setBaseselectedtag', 'home');
                  this.$store.commit('setLocationnow', '首页');
                })
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(menu.Icon), {
                    color: "white"
                  }))]),
                  _: 2
                }, 1024), _createElementVNode("span", _hoisted_2, _toDisplayString(menu.Display), 1)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), menu.Children && menu.Children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 1,
                index: menu.Id
              }, {
                title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(menu.Icon), {
                    color: "white"
                  }))]),
                  _: 2
                }, 1024), _createElementVNode("span", _hoisted_3, _toDisplayString(menu.Display), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.Children, child => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: child,
                    onClick: $event => $options.changepage(child, menu),
                    index: child.Id,
                    route: child.Path
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(child.Icon)))]),
                      _: 2
                    }, 1024), _createElementVNode("span", _hoisted_4, _toDisplayString(child.Display), 1)]),
                    _: 2
                  }, 1032, ["onClick", "index", "route"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
            }), 128))]),
            _: 1
          }, 8, ["collapse", "default-openeds", "default-active"])]),
          _: 1
        }, 8, ["style"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["class"]), _createVNode(_component_el_main, {
      style: {
        "margin": "0",
        "padding": "0"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_container, {
        style: {
          "margin": "0",
          "padding": "0",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          style: {
            "height": "auto",
            "padding": "0",
            "background-color": "#F2F3F4",
            "border-bottom": "1px solid gray"
          },
          id: "baseheader"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$data.showaside ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            onClick: _cache[2] || (_cache[2] = () => {
              this.showaside = false;
            }),
            style: {
              "vertical-align": "center"
            },
            size: "30px"
          }, {
            default: _withCtx(() => [_createVNode(_component_Fold)]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            onClick: _cache[3] || (_cache[3] = () => {
              this.showaside = true;
            }),
            style: {
              "vertical-align": "middle"
            },
            size: "30px"
          }, {
            default: _withCtx(() => [_createVNode(_component_Expand)]),
            _: 1
          }))]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_dropdown, {
            trigger: "click"
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.main_body_list, item => {
                return _openBlock(), _createBlock(_component_el_dropdown_item, {
                  onClick: $event => $options.changeMainBody(item.SellerTaxNumber, item.SellerName)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [item.SellerTaxNumber == _ctx.$store.state.main_body_id ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0
                    })) : _createCommentVNode("", true)]),
                    _: 2
                  }, 1024), _createTextVNode(" " + _toDisplayString(item.SellerName), 1)]),
                  _: 2
                }, 1032, ["onClick"]);
              }), 256))]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_icon, {
              size: 25,
              style: {
                "width": "30px",
                "vertical-align": "middle",
                "cursor": "pointer"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_Switch)]),
              _: 1
            }), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$store.state.username), 1)])]),
            _: 1
          }), _createVNode(_component_el_tooltip, {
            effect: "light"
          }, {
            content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messagenoticeparams.unread_messagelist.slice(0, $data.messagenoticeparams.unread_messagelist.length > 3 ? 3 : $data.messagenoticeparams.unread_messagelist.length), item => {
              return _openBlock(), _createElementBlock("div", {
                key: item,
                style: {
                  "font-size": "14px",
                  "padding": "5px",
                  "color": "rgb(128, 128, 128)"
                }
              }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
                style: {
                  "margin-top": "3px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                _: 1
              })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.Title), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.Content.length > 25 ? item.Content.slice(0, 20) + '...' : item.Content), 1)])])]);
            }), 128))]),
            default: _withCtx(() => [_createVNode(_component_el_badge, {
              style: {
                "width": "30px",
                "vertical-align": "middle",
                "margin-left": "12px",
                "margin-right": "8px",
                "cursor": "pointer"
              },
              value: $data.msglist.length,
              hidden: $data.msglist.length == 0
            }, {
              default: _withCtx(() => [_createVNode(_component_el_badge, {
                value: $data.messagenoticeparams.unread_count,
                hidden: $data.messagenoticeparams.unread_count == 0,
                class: "item"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_image, {
                  onClick: _cache[4] || (_cache[4] = () => {
                    this.messagenoticeparams.selectedtag = 0;
                    this.getmessagedata();
                    this.showmessagenoticedialog = true;
                  }),
                  style: {
                    "width": "30px",
                    "vertical-align": "middle",
                    "cursor": "pointer"
                  },
                  fit: "cover",
                  src: "/disney/backui/email.png"
                })]),
                _: 1
              }, 8, ["value", "hidden"])]),
              _: 1
            }, 8, ["value", "hidden"])]),
            _: 1
          }), _createVNode(_component_el_tooltip, {
            effect: "light",
            content: "登出",
            placement: "bottom"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              onClick: $options.logout_button,
              style: {
                "width": "25px",
                "margin-left": "15px",
                "vertical-align": "middle",
                "cursor": "pointer"
              },
              fit: "cover",
              src: "/disney/backui/logout.png"
            }, null, 8, ["onClick"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_14, "当前位置：" + _toDisplayString(_ctx.$store.state.locationnow), 1)]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$store.state.basetagslist), item => {
            return _openBlock(), _createBlock(_component_el_tag, {
              key: item,
              closable: item != 'home',
              onClick: $event => $options.singletagclick(item),
              onClose: $event => $options.singletagdelete(item),
              style: {
                "cursor": "pointer",
                "margin-left": "5px",
                "margin-bottom": "5px"
              },
              size: "large",
              type: _ctx.$store.state.baseselectedtag == item ? '' : 'info',
              effect: _ctx.$store.state.baseselectedtag == item ? 'dark' : 'light'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$store.state.basetagslist[item]['label']), 1)]),
              _: 2
            }, 1032, ["closable", "onClick", "onClose", "type", "effect"]);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_main, {
          class: "routermain",
          id: "basemain",
          style: {
            "background-color": "#F2F3F4"
          }
        }, {
          default: _withCtx(() => [$data.isRouterAlive ? (_openBlock(), _createBlock(_component_router_view, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_dialog, {
      modelValue: $data.showmessagenoticedialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.showmessagenoticedialog = $event),
      width: "850",
      top: "12vh",
      "show-close": false,
      onClose: _cache[13] || (_cache[13] = () => {
        this.params.page = 1;
      })
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", null, [_createVNode(_component_el_tag, {
        onClick: _cache[9] || (_cache[9] = () => {
          this.params.page = 1;
          this.messagenoticechangetag(0);
        }),
        size: "large",
        type: $data.messagenoticeparams.selectedtag == 0 ? '' : 'info',
        effect: $data.messagenoticeparams.selectedtag == 0 ? 'dark' : 'light',
        style: {
          "border-top-right-radius": "0",
          "border-bottom-right-radius": "0",
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 未读 ")]),
        _: 1
      }, 8, ["type", "effect"]), _createVNode(_component_el_tag, {
        onClick: _cache[10] || (_cache[10] = () => {
          this.params.page = 1;
          this.messagenoticechangetag(1);
        }),
        size: "large",
        type: $data.messagenoticeparams.selectedtag == 1 ? '' : 'info',
        effect: $data.messagenoticeparams.selectedtag == 1 ? 'dark' : 'light',
        style: {
          "border-top-left-radius": "0",
          "border-bottom-left-radius": "0",
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 全部 ")]),
        _: 1
      }, 8, ["type", "effect"]), _createVNode(_component_el_button, {
        style: {
          "margin-left": "20px"
        },
        icon: "Finished",
        onClick: $options.messagenoticereadallmessage
      }, {
        default: _withCtx(() => [_createTextVNode(" 全部标为已读 ")]),
        _: 1
      }, 8, ["onClick"])])])]),
      footer: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: _cache[11] || (_cache[11] = $event => $data.showmessagenoticedialog = false)
      }, {
        default: _withCtx(() => [_createTextVNode("关闭")]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_el_container, {
        style: {
          "height": "420px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_main, {
          style: {
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: $data.messagenoticeparams.messagelist,
            style: {
              "width": "100%",
              "height": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, null, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_15, [scope.row.IsRead == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_tooltip, {
                content: "标记为已读",
                effect: "light"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "20",
                  style: {
                    "cursor": "pointer"
                  },
                  onClick: $event => $options.messagenoticereadsinglemessage(scope.row)
                }, {
                  default: _withCtx(() => [_createVNode(_component_Finished)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.Title), 1), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createTextVNode(_toDisplayString(scope.row.Content), 1)])]), _createElementVNode("div", _hoisted_20, " 时间：" + _toDisplayString(scope.row.ReceiveTime), 1)])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_pagination, {
            background: "",
            "page-size": $data.params.size,
            "onUpdate:pageSize": _cache[5] || (_cache[5] = $event => $data.params.size = $event),
            total: $data.params.total,
            "current-page": $data.params.page,
            "onUpdate:currentPage": _cache[6] || (_cache[6] = $event => $data.params.page = $event),
            "page-sizes": [20, 50, 80, 100],
            layout: "sizes,prev,pager,next,jumper,->,total",
            onSizeChange: _cache[7] || (_cache[7] = size => {
              this.params.page = 1;
              this.messagenoticechangetag_auto();
            }),
            onCurrentChange: _cache[8] || (_cache[8] = page => {
              this.messagenoticechangetag_auto();
            })
          }, null, 8, ["page-size", "total", "current-page"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}